/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentDeliveryPlans } from 'app/entities/treatment-delivery-plan/treatment-delivery-plan.reducer';
import { getEntities as getTreatmentRegimen } from 'app/entities/treatment-regimen/treatment-regimen.reducer';
import { getEntities as getTreatmentCycles } from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import { getEntities as getRegimenInvestigations } from 'app/entities/regimen-investigation/regimen-investigation.reducer';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';
import { createEntity, getEntity, reset, updateEntity } from './treatment-regimen-investigation.reducer';

export const TreatmentRegimenInvestigationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentDeliveryPlans = useAppSelector(state => state.treatmentDeliveryPlan.entities);
  const treatmentRegimen = useAppSelector(state => state.treatmentRegimen.entities);
  const treatmentCycles = useAppSelector(state => state.treatmentCycle.entities);
  const regimenInvestigations = useAppSelector(state => state.regimenInvestigation.entities);
  const treatmentRegimenInvestigationEntity = useAppSelector(state => state.treatmentRegimenInvestigation.entity);
  const loading = useAppSelector(state => state.treatmentRegimenInvestigation.loading);
  const updating = useAppSelector(state => state.treatmentRegimenInvestigation.updating);
  const updateSuccess = useAppSelector(state => state.treatmentRegimenInvestigation.updateSuccess);
  const associationTypeValues = Object.keys(AssociationType);

  const handleClose = () => {
    navigate(`/treatment-regimen-investigation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentDeliveryPlans({}));
    dispatch(getTreatmentRegimen({}));
    dispatch(getTreatmentCycles({}));
    dispatch(getRegimenInvestigations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cycleNumber !== undefined && typeof values.cycleNumber !== 'number') {
      values.cycleNumber = Number(values.cycleNumber);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentRegimenInvestigationEntity,
      ...values,
      plan: treatmentDeliveryPlans.find(it => it.id.toString() === values.plan?.toString()),
      regimen: treatmentRegimen.find(it => it.id.toString() === values.regimen?.toString()),
      cycle: treatmentCycles.find(it => it.id.toString() === values.cycle?.toString()),
      metaDiagnosis: regimenInvestigations.find(it => it.id.toString() === values.metaDiagnosis?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          associationType: 'PATHOLOGY',
          ...treatmentRegimenInvestigationEntity,
          plan: treatmentRegimenInvestigationEntity?.plan?.id,
          regimen: treatmentRegimenInvestigationEntity?.regimen?.id,
          cycle: treatmentRegimenInvestigationEntity?.cycle?.id,
          metaDiagnosis: treatmentRegimenInvestigationEntity?.metaDiagnosis?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.treatmentRegimenInvestigation.home.createOrEditLabel"
            data-cy="TreatmentRegimenInvestigationCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.home.createOrEditLabel">
              Create or edit a TreatmentRegimenInvestigation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-regimen-investigation-id"
                  label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.cycleNumber')}
                id="treatment-regimen-investigation-cycleNumber"
                name="cycleNumber"
                data-cy="cycleNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.associationType')}
                id="treatment-regimen-investigation-associationType"
                name="associationType"
                data-cy="associationType"
                type="select"
              >
                {associationTypeValues.map(associationType => (
                  <option value={associationType} key={associationType}>
                    {translate(`tinyMedicRestApp.AssociationType.${associationType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.active')}
                id="treatment-regimen-investigation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.cursor')}
                id="treatment-regimen-investigation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.lastUpdated')}
                id="treatment-regimen-investigation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.microSec')}
                id="treatment-regimen-investigation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.timestampEntry')}
                id="treatment-regimen-investigation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-regimen-investigation-plan"
                name="plan"
                data-cy="plan"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.plan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentDeliveryPlans
                  ? treatmentDeliveryPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRegimen
                  ? treatmentRegimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentCycles
                  ? treatmentCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-metaDiagnosis"
                name="metaDiagnosis"
                data-cy="metaDiagnosis"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigation.metaDiagnosis')}
                type="select"
              >
                <option value="" key="0" />
                {regimenInvestigations
                  ? regimenInvestigations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/treatment-regimen-investigation"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentRegimenInvestigationUpdate;
